import { render, staticRenderFns } from "./QuillEdtor.vue?vue&type=template&id=944e7000"
import script from "./QuillEdtor.vue?vue&type=script&lang=js"
export * from "./QuillEdtor.vue?vue&type=script&lang=js"
import style0 from "./QuillEdtor.vue?vue&type=style&index=0&id=944e7000&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('944e7000')) {
      api.createRecord('944e7000', component.options)
    } else {
      api.reload('944e7000', component.options)
    }
    module.hot.accept("./QuillEdtor.vue?vue&type=template&id=944e7000", function () {
      api.rerender('944e7000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuillEditor/QuillEdtor.vue"
export default component.exports